module.exports = __webpack_public_path__ + "static/media/prism flyer in the wild.65f56b65.jpg";